<template>
  <div>
    <titulo-modulo
      :titulo="
        tiposTreinamento.find((t) => t.tipo == $route.params.tipo).descricao
      "
    ></titulo-modulo>
    <v-progress-linear
      indeterminate
      v-if="carregando"
      class="mt-3"
    ></v-progress-linear>
    <template v-else-if="treinamentos.length > 0">
      <v-expansion-panels v-if="treinamentos[0].cod_curso == 0" class="mt-3">
        <v-expansion-panel v-for="gpTreino in treinamentos" :key="gpTreino.id">
          <v-expansion-panel-header>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">{{
                  gpTreino.nome
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  gpTreino.descricao
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card
              v-for="treino in gpTreino.treinamentos"
              :key="treino.id"
              color="grey lighten-3"
              class="mb-2"
              flat
            >
              <v-card-text>
                <v-row>
                  <v-col xl="3" lg="4" md="4" cols="12">
                    <iframe
                      width="100%"
                      height="220"
                      :src="'https://www.youtube.com/embed/' + treino.idvideo"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; picture-in-picture"
                      allowfullscreen
                    ></iframe>
                  </v-col>
                  <v-col xl="9" lg="8" md="8" cols="12">
                    <v-card-title class="font-weight-bold black--text title">{{
                      treino.titulo
                    }}</v-card-title>
                    <v-card-subtitle class="subtitle-1">{{
                      treino.descricao
                    }}</v-card-subtitle>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <template v-else>
        <btn-emitir-declaracao-cursos />
        <v-card flat class="mt-3">
          <v-card-text class="pt-2 pb-2">
            <v-text-field
              label="Pesquisar treinamento"
              v-model="pesquisa"
              :messages="`${
                treinamentosFiltrados().length
              } treinamentos encontrados`"
            ></v-text-field>
          </v-card-text>
        </v-card>
        <v-card flat class="mt-2">
          <v-card-text v-if="treinamentosFiltrados().length == 0">
            Nenhum treinamento localizado com esta pesquisa
          </v-card-text>
          <v-virtual-scroll
            v-else
            :items="treinamentosFiltrados()"
            item-height="90"
            :max-height="tela().availHeight * 0.56"
            :bench="treinamentosFiltrados().length"
          >
            <template v-slot:default="{ item }">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">{{
                    item.descricao
                  }}</v-list-item-title>
                  <v-list-item-subtitle class="mt-2">
                    <p class="mb-1">
                      <v-icon small class="mr-2">mdi-calendar</v-icon
                      ><span
                        >{{ formatarData(item.data_inicial) }} a
                        {{ formatarData(item.data_final) }}</span
                      >
                    </p>
                    <p>
                      <v-icon small class="mr-2">mdi-clock-outline</v-icon>
                      <span>{{ item.carga_horaria }}</span>
                    </p>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
          </v-virtual-scroll>
        </v-card>
      </template>
    </template>
    <v-alert type="info" text v-else class="mt-3">
      Nenhum treinamento encontrado
    </v-alert>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TituloModulo from "../../components/TituloModulo.vue";
import { dateFormat } from "@/global";
import BtnEmitirDeclaracaoCursos from "./components/BtnEmitirDeclaracaoCursos.vue";

export default {
  components: { TituloModulo, BtnEmitirDeclaracaoCursos },
  computed: {
    ...mapState("treinamento", ["treinamentos", "tiposTreinamento", "filtro"]),
  },
  data: () => ({
    carregando: true,
    pesquisa: "",
  }),
  methods: {
    ...mapActions("treinamento", ["getTreinamentos"]),
    formatarData(value) {
      return dateFormat(value);
    },
    tela() {
      return screen;
    },
    treinamentosFiltrados() {
      return this.treinamentos.filter((t) =>
        t.descricao.toLowerCase().includes(this.pesquisa.toLowerCase())
      );
    },
    isMobile() {
      return this.$mq == "sm";
    },
  },
  async mounted() {
    this.carregando = true;
    this.filtro.tipo = this.$route.params.tipo;
    await this.getTreinamentos();
    this.carregando = false;
  },
};
</script>

<style>
</style>